export const templateTypes = {
  confirmation: 'APPT_CONFIRMATION',
  reminder: 'APPT_REMINDER',
  estimate: 'ESTIMATE',
  inspection: 'INSPECTION',
  reschedule: 'APPT_RESCHEDULE',
  cancel: 'APPT_CANCEL',
  requestReceived: 'APPT_REQ_RECIEVED',
  requestDeclined: 'APPT_REQ_DECLINED',
  disclaimer: 'DISCLAIMER',
  warrantyDisclaimer: 'WARRANTY_DISCLAIMER',
  tireWarrantyPolicy: 'TIRE_WARRANTY_POLICY',
  invDisclaimer: 'INV_DISCLAIMER',
  welcome: 'WELCOME',
  setPassword: 'SET_PASSWORD',
  resetPassword: 'RESET_PASSWORD',
  invoice: 'INVOICE',
  estimateDeposit: 'ESTIMATE_DEPOSIT_REQUEST',
  estimateDepositReminder: 'DEPOSIT_REQUEST_REMINDER',
  receipt: 'RECEIPT',
  replyConfirm: 'APPT_REPLY_CONFIRM',
  replyCancel: 'APPT_REPLY_CANCEL',
  review: 'REVIEW',
  googleReview: 'GOOGLE_REVIEW',
  review_receipt: 'RECEIPT_REVIEW',
  review_receipt_google: 'RECEIPT_REVIEW_GOOGLE',
  review_request: 'REVIEW_REQUEST',
  review_request_google: 'REVIEW_REQUEST_GOOGLE',
  fleet_statement: 'FLEET_STATEMENT',
  bulk_payment: 'BULK_PAYMENT',
  review_reminder: 'REVIEW_REMINDER',
  review_reminder_google: 'REVIEW_REMINDER_GOOGLE',
  estimate_approval_reminder: 'ESTIMATE_APPROVAL_REMINDER',
  invoice_vehicle_pickup: 'INVOICE_VEHICLE_PICKUP',
  email_campaign: 'EMAIL_CAMPAIGN',
  template_Announcement: 'MARKETING_ANN',
  template_Product: 'MARKETING_PRD',
  template_Classic: 'CLASSIC',
  template_Festive: 'FESTIVE',
  template_Modern: 'MODERN',
  template_Newsletter: 'NEWSLETTER',
  template_business_summary_report: 'BUSINESS_SUMMARY_REPORT',
  template_royalty_report: 'ROYALTY_REPORT'
};
